export default {
	showEditViewLocalization: false,
	languageList:{
        data: null,
        links: null,
        meta: null
    },
}
